<form style="background-color: white; padding: 20px; border-radius: 5px;" class="row" [formGroup]="publisherForm">

  <!-- Publisher Name -->
  <div class="form-group col-md-6">
    <label for="name">Tên Nhà Xuất Bản:</label>
    <i class="fas fa-info-circle" data-toggle="tooltip" 
       title="Mô tả: Nhập tên nhà xuất bản. Ví dụ: Nhà Xuất Bản Kim Đồng"></i>
    <input [ngClass]="{ 'is-invalid': submitted && f.name.errors }" formControlName="name" id="field-category_name" 
           name="name" class="form-control" type="text" maxlength="99" placeholder="ví dụ: Nhà Xuất Bản Kim Đồng" />
    <!-- Publisher Name Validation -->
    <!-- <div *ngIf="submitted && f.name.errors" class="alert alert-danger">
      <div *ngIf="submitted && f.name.errors.required">
        {{ msg.validationMessage.name }}
      </div>
    </div> -->
  </div>

  <!-- Address -->
  <div class="form-group col-md-6">
    <label for="address">Địa Chỉ:</label>
    <i class="fas fa-info-circle" data-toggle="tooltip" 
       title="Mô tả: Nhập địa chỉ nhà xuất bản. Ví dụ: 123 Đường Xuất Bản"></i>
    <input
       id="addressInput"
       formControlName="address"
       class="form-control"
       type="text"
       placeholder="ví dụ: 123 Đường Xuất Bản"
     />
    <!--  <div *ngIf="publisherForm.get('address').invalid && (publisherForm.get('address').dirty || publisherForm.get('address').touched)">
       <small class="text-danger" *ngIf="publisherForm.get('address').errors.required">Địa chỉ là bắt buộc.</small>
     </div> -->
  </div>

  <!-- Email -->
  <div class="form-group col-md-6">
    <label for="email">Email:</label>
    <i class="fas fa-info-circle" data-toggle="tooltip" 
       title="Mô tả: Nhập email của nhà xuất bản. Ví dụ: lienhe@nhaxuatban.com"></i>
    <input formControlName="email" id="field-email" name="email" class="form-control" type="email" maxlength="99" placeholder="ví dụ: lienhe@nhaxuatban.com" />
  </div>

  <!-- Phone -->
  <div class="form-group col-md-6">
    <label for="phone">Số Điện Thoại:</label>
    <i class="fas fa-info-circle" data-toggle="tooltip" 
       title="Mô tả: Nhập số điện thoại của nhà xuất bản. Ví dụ: +84-123-456-789"></i>
    <input formControlName="phone" id="field-phone" name="phone" class="form-control" type="text" maxlength="99" placeholder="ví dụ: +84-123-456-789" />
  </div>

  <!-- Country -->
  <div class="form-group col-md-6">
    <label for="country">Quốc gia:</label>
    <i class="fas fa-info-circle" data-toggle="tooltip" 
       title="Mô tả: Chọn quốc gia của nhà xuất bản."></i>
    <ng-select
      [items]="countries"
      bindLabel="name"
      bindValue="code"
      placeholder="Start typing to search for a country..."
      formControlName="country"
      [ngClass]="{ 'is-invalid': submitted && f.country.errors }"
    >
    </ng-select>
   <!--  <div *ngIf="submitted && f.country.errors" class="alert alert-danger">
      <div *ngIf="submitted && f.country.errors.required">
        {{ msg.validationMessage.country }}
      </div>
    </div> -->
  </div>

  <!-- Website -->
  <div class="form-group col-md-6">
    <label for="website">Website:</label>
    <i class="fas fa-info-circle" data-toggle="tooltip" 
       title="Mô tả: Nhập website của nhà xuất bản. Ví dụ: www.publisherwebsite.com"></i>
    <input formControlName="website" id="field-website" name="website" class="form-control" type="text" maxlength="99" placeholder="ví dụ: www.publisherwebsite.com" />
  </div>

  <!-- Add Button -->
  <div class="form-group col-md-12">
    <button (click)="add()" type="button" class="btn btn-outline-primary">
      <i class="fas fa-save"></i>
      {{ publisherI18n?.addButtonI18n }}
    </button>
  </div>
</form>



